import { DynamicValue } from "@faedev/dynamic-values";
import { composeClassNames, log } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { useState } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { useCookies } from "react-cookie";
import Translate from "src/components/Translate";
import constants from "src/constants";
import gutter from "src/functions/gutter";
import isFormValid from "src/functions/isFormValid";
import onChangeToValue from "src/functions/onChangeToValue";
import translate from "src/functions/translate";
import Small_cancel from "src/icons/Small-cancel";
import { sAlert } from "src/styles/sAlert.module.scss";
import { sButton } from "src/styles/sButton.module.scss";
import { sButtonClose } from "src/styles/sButtonClose.module.scss";
import { sButtons } from "src/styles/sButtons.module.scss";
import { sFormControl } from "src/styles/sFormControl.module.scss";
import { sFormLabel } from "src/styles/sFormLabel.module.scss";
import { sModal } from "src/styles/sModal.module.scss";
import { sModalAuth } from "src/styles/sModalAuth.module.scss";
import { sNote } from "src/styles/sNote.module.scss";

type Props = {
  className?: (string | string) | null | undefined;
  openModalResetPassword?: DynamicValue<boolean>;
  setAlertResetPassword?: (setAlertResetPassword: boolean) => void;
};

function ModalResetPassword({
  className,
  openModalResetPassword,
  setAlertResetPassword,
}: Props) {
  const { locale: lang } = useRouter();
  var [state, setState] = useState({ email: `` });
  var [validated, setValidated] = useState(false);
  var [cookies, setCookie] = useCookies();
  const [failed, setFailed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  return (
    <Modal
      show={openModalResetPassword.value}
      className={composeClassNames([sModal, sModalAuth, "modal-password"])}
      size="sm"
      onHide={() => openModalResetPassword.change(false)}
    >
      <Modal.Header>
        <Modal.Title>
          <Translate tKey={`Forgot password?`} />
        </Modal.Title>
        <Button
          variant="link"
          onClick={function () {
            return openModalResetPassword.change(false);
          }}
          size="sm"
          className={composeClassNames([sButtonClose, `btn-close`])}
        >
          <Small_cancel />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Form id={`FormForgottenPassword`} validated={validated} noValidate>
          <Form.Group>
            <Form.Label className={sFormLabel}>
              <Translate tKey={`Email`} />
            </Form.Label>
            <Form.Control
              type={`email`}
              className={sFormControl}
              placeholder={translate(`Enter email`, lang)}
              name={`identifier`}
              id={`identifier`}
              onChange={function (param2) {
                return setState({ email: onChangeToValue(param2) });
              }}
              value={state.email}
              required={true}
            />
            <Form.Control.Feedback type="invalid">
              <Translate tKey={constants.Form.mandatoryMessage} />
            </Form.Control.Feedback>
            <Form.Text className={sNote}>
              <Translate
                tKey={`A link will be sent to the email you entered to reset your password.`}
              />
            </Form.Text>
          </Form.Group>
          <div
            className={composeClassNames([sButtons, "buttons", "align-center"])}
          >
            <Button
              className={composeClassNames([sButton, "btn-submit"])}
              variant="primary"
              onClick={async function () {
                return await (async function iife() {
                  setValidated(true);
                  isFormValid(`FormForgottenPassword`)
                    ? await (async function iife() {
                        var result = await (() =>
                          fetch(
                            `${constants.Paths.apiUrl}/auth/forgot-password`,
                            {
                              body: JSON.stringify(state),
                              method: "POST",
                              headers: { "Content-Type": "application/json" },
                            }
                          ).then(async (res) => {
                            if (res.ok) {
                              setState({ email: `` });
                              openModalResetPassword.change(false);
                              setAlertResetPassword(true);
                              return res.json();
                            } else {
                              // throw new Error("API Error");
                              const error = await res.json();
                              if (
                                error.message[0]?.messages[0]?.id ===
                                "Auth.form.error.user.not-exist"
                              ) {
                                setState({ email: `` });
                                openModalResetPassword.change(false);
                                setAlertResetPassword(true);
                              } else {
                                setFailed(true);
                                setErrorMessage(
                                  `Password reset failed. Please try again.`
                                );
                              }
                            }
                          }))();
                        return log(result);
                      })()
                    : null;
                })();
              }}
            >
              <Translate tKey={`Reset password`} />
            </Button>
            {failed && (
              <Alert
                variant="danger"
                className={sAlert}
                style={gutter(`margin`, `vertical`, `md`)}
              >
                <Translate tKey={errorMessage} />
              </Alert>
            )}
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default ModalResetPassword;
